<template>
  <v-dialog persistent :value="value" @input="$emit('input')" max-width="500px">
    <v-card>
      <v-toolbar dense class="">
        <v-toolbar-title>Report Passcode</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <!-- Popup content -->
        <v-card>
          <v-card-text>
              <v-text-field
                prepend-icon="security"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :type="show1 ? 'text' : 'password'" label="Enter Passcode"
                v-model="passcode"
                :error-messages="passcodeErrors"
                hint="Recommended for at least 8 characters"
                counter
                @click:append="show1 = !show1" 
                @input="$v.passcode.$touch()"
                @blur="$v.passcode.$touch()"
                @keydown.space.prevent
                @paste="preventPasteSpaces" 
              ></v-text-field>
          </v-card-text>
          <!-- Footer -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal"> Close </v-btn>
            <v-btn class="success" @click="resetPasscode">Save changes</v-btn>
          </v-card-actions>
        </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import campaignAPIs from './campaignAPIs';
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate';

export default {
  name: 'ReportPasscodeModal',
  props: {
    campaign: Object,
    value: Boolean
  },
  mixins: [validationMixin],
  data () {
    return {
      show1: false,
      passcode: ''
    }
  },
  validations: {
    passcode: {
      required
    }
  },
  computed: {
    passcodeErrors() {
      const errors = [];
      if (!this.$v.passcode.$dirty) return errors;
      !this.$v.passcode.required && errors.push('Passcode is required');
      return errors;
    }
  },
  methods: {
    resetPasscode: function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      }

      campaignAPIs.resetPasscode(this.campaign.id, this.passcode)
        .then(response => {
          // Dismiss modal by triggering the click event on Close button
          this.$swal({
            title: 'Success',
            text: 'Successfully Changed Passcode.',
            type: 'success'
          }).then(() => {
            this.$emit('updated')
            this.closeModal()
          })
        })
        .catch(error => {
          // Request failed.
          this.$swal({
            title: 'Error',
            type: 'error',
            text: error
          })
          console.log('error', error)
        })
    },
    closeModal: function () {
      this.$v.$reset()
      this.$emit('input')
      this.passcode = ''
    },
    // Remove spaces after input (to clear spaces if pasted somehow)
    removeSpaces() {
      this.$v.passcode.$touch()
      this.passcode = this.passcode.replace(/\s/g, '');
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReportPasscodeModal.vue?6d8e7a16